module.exports = __webpack_public_path__ + "img/emoji_01.c91a3d7b.png";